import type { BranchNameType, ModuleIdType } from '../types.js'
import { BoReference } from '../bos/bo-reference.js'
import * as z from 'zod'

export const deploymentSpecificationSchema = z.strictObject({
	branchName: z.string(),
	wholeModules: z
		.strictObject({
			moduleId: z.string(),
			includeImportedModules: z.boolean(),
		})
		.array()
		.optional(),
	bos: z.instanceof(BoReference).array().optional(),
	settings: z.instanceof(BoReference).array().optional(),
})

export type DeploymentSpecification = z.infer<
	typeof deploymentSpecificationSchema
>

// export interface DeploymentSpecification {
// 	branchName: BranchNameType
// 	wholeModules?: {
// 		moduleId: ModuleIdType
// 		includeImportedModules: boolean
// 	}[]
// 	bos?: BoReference[]
// 	settings?: BoReference[]
// }
